var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StringUtils } from '../../utils';
export var Pill = function (props) {
    var _a;
    return (_jsxs("span", __assign({ className: StringUtils.combineStrings(['localina-pill', (_a = props.tone) !== null && _a !== void 0 ? _a : 'neutral', props.extraClassName]), title: props.title }, { children: [props.icon && _jsx("span", __assign({ className: "localina-pill__icon" }, { children: props.icon })), _jsx("span", __assign({ className: "localina-pill__label" }, { children: props.label }))] })));
};
